import type { DocumentsLinkData } from './useDocumentsLinkData.types';

import * as errorUtils from 'utils/errors';
import { createShortUrl } from 'shared/features/urlShortener/urlShortener.api';
import { copyTextToClipboard } from 'utils/dom';
import { APP_CONTEXT } from 'components/UserAccount/elements/EmailNotifications/EmailNotifications.constants';

import { useMutation } from '@tanstack/react-query';

export const useDocumentsLinkMutations = ({
  localActions,
  formattedData
}: {
  localActions: DocumentsLinkData['localActions'];
  formattedData: DocumentsLinkData['formattedData'];
}) => {
  const getShortURL = useMutation<string, Error, unknown>({
    mutationFn: async () => {
      const shortURLResponse = await createShortUrl({
        url: window.location.href,
        application: APP_CONTEXT.CAI
      });
      return shortURLResponse.url;
    },
    onSuccess: url => {
      if (formattedData.isSafari) {
        localActions.setUrl(url);
        localActions.setIsModalOpen(true);
        return;
      }
      copyTextToClipboard(url);
    },
    onError: errorUtils.logReactQueryError,
    throwOnError: false
  });

  return {
    getShortURL
  };
};
